import { useAuthContext, useBookingProposalCustomer } from 'noddi-web';

/** A proposal keeps its customer when edited in the ordinary mobile booking flow. */
export function useMobileBookingCustomer() {
  const { currentUserGroupId, userData } = useAuthContext();
  const proposalCustomer = useBookingProposalCustomer();
  return {
    userGroupId: proposalCustomer?.userGroupId ?? currentUserGroupId,
    userId: proposalCustomer?.userId ?? userData?.user.id
  };
}
